import { useI18n } from 'vue-i18n'

import { SurveyResponseState } from '@/composables/useSurveyResponseState.ts'
import { SurveyResponseRejectedReasons } from '@/gql/reviews'

export default function getMessageBannerForReviewState(
  reviewState: SurveyResponseState,
  reviewerFirstName: string,
  rejectReason: SurveyResponseRejectedReasons | null | undefined,
  canSendReminder: boolean | null | undefined,
  hasOldReview: boolean = false,
) {
  const { t } = useI18n()

  let rejectedText: string
  const rejectedReasonText = t(`Reviews.product.review.rejected.reason.${rejectReason || SurveyResponseRejectedReasons.Invalid}`)
  if (canSendReminder) {
    rejectedText = t('Reviews.product.review.rejected.remindable.messageBanner.description', {
      reason: rejectedReasonText,
    })
  } else {
    rejectedText = t('Reviews.product.review.rejected.notRemindable.messageBanner.description', {
      reason: rejectedReasonText,
    })
  }

  switch (reviewState) {
    case SurveyResponseState.Rejected:
      return {
        headline: t('Reviews.product.review.rejected.messageBanner.headline'),
        text: rejectedText,
        type: 'error' as const,
      }
    case SurveyResponseState.Drafted:
    case SurveyResponseState.Stale:
      if (!canSendReminder) {
        return {
          headline: t('Reviews.product.review.draftedOrStale.blockedHeadline'),
          text: t('Reviews.product.review.draftedOrStale.blockedMessage', { authorName: reviewerFirstName }),
          type: 'info' as const,
        }
      }
      return {
        headline: t('Reviews.product.review.draftedOrStale.headline'),
        text: t('Reviews.product.review.draftedOrStale.message', { authorName: reviewerFirstName }),
        type: 'info' as const,
      }
    case SurveyResponseState.ReDrafted:
      return {
        headline: t('Reviews.product.review.reDrafted.headline'),
        text: t('Reviews.product.review.reDrafted.message', { authorName: reviewerFirstName }),
        type: 'info' as const,
      }
    case SurveyResponseState.Published:
      if (hasOldReview) {
        return {
          headline: t('Reviews.product.review.publishedAndOld.headline'),
          text: t('Reviews.product.review.publishedAndOld.message', { authorName: reviewerFirstName }),
          type: 'reminder' as const,
          inline: 'top' as const,
        }
      }
      return null
    default:
      return null
  }
}
